var React = require('react');

function FilterIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.426753 0.046875C0.0744799 0.046875 -0.125545 0.450132 0.087608 0.730599L4.74596 6.86004C4.77763 6.90171 4.80113 6.94857 4.81564 6.99815V11.5777C4.81564 11.913 5.1852 12.1169 5.46886 11.938L6.98937 10.979C7.11307 10.9009 7.1881 10.7649 7.1881 10.6187V7.02973C7.18878 7.0288 7.18947 7.02787 7.19016 7.02695L11.914 0.728433C12.1246 0.447615 11.9243 0.046875 11.5733 0.046875H0.426753Z","fill":"#2B2B2B"}));
}

FilterIconInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = FilterIconInline;

FilterIconInline.default = FilterIconInline;
